import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { Alert } from '@mui/material';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { MobileView } from './layout/small';
import { DesktopTable } from './layout/medium';
import { memo } from 'react';
export const CompareCards = memo(function CompareCards(props) {
    const { error } = props;
    return (_jsxs(ErrorBoundary, { children: [error && _jsx(Alert, { severity: "error", children: error }), isMediumUI() ? _jsx(DesktopTable, { ...props }) : _jsx(MobileView, { ...props })] }));
});
